module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Wiliberg_AG-76b27f37f38bb10d77702cecb116d56c.svg";